<template>
	<select-trigger-popup v-if="stepComponent === 'Step1'" :automation="localAutomation"
	                      :is-edit="isEdit"  :is-plus="isPlus"
	                      @close="closePopup" @done="step1Done" />
	<select-integration-popup v-else-if="stepComponent === 'Step2'" :automation="localAutomation"
	                          :is-edit="isEdit" @done="step2Done"  :is-plus="isPlus"
	                          @config="currentIntegration=$event;stepComponent='config'"
	                          @close="closePopup" @back="stepComponent='Step1'" />
	<action-popup v-else-if="stepComponent === 'Step3'" :automation="localAutomation" :is-plus="isPlus"
	                          :is-edit="isEdit" :product="product" @done="$emit('done',$event)"
	                          @close="closePopup" @back="stepComponent='Step2'" />

	<integration-settings-popup v-else-if="stepComponent==='config'" @close="closePopup"
	                            @back="stepComponent='Step2'"  :is-plus="isPlus"
	                            :integration="currentIntegration" @done="stepComponent='Step2'" />

	<popup v-else class="automation-popup"
	       :title="`${isEdit?'Edit':'Create a new'} automation`" relative  @close="closePopup">
		<template v-slot:content>
			<Loading v-show="loading"/>
			<div class="__content">
				<div class="automation-progress-panel">
					<div class="item-prog" :class="{deactivated: step.status === 'deactivated'}" v-for="step in steps" :key="step.id">
						<div class="icon-status" :class="{active: step.status === 'active'}">
							<inline-svg v-if="step.status === 'active' || step.status === 'deactivated'" :src="require('@/assets/img/circle-arrow-right.svg')"/>
							<inline-svg v-if="step.status === 'completed'" :src="require('@/assets/img/circle-checked.svg')"/>
						</div>
						<div class="item-prog-text">
							<span>{{step.name}}</span>
							<div v-if="step.status === 'completed'" class="prog-details-label">{{step.label}}</div>
						</div>
					</div>
				</div>

				<div class="step-items scroll">
					<Step1
							v-if="stepComponent === 'Step1'"
							:data="flag.id ? flag : false"
							@done="firstDone"
					/>
					<Step2
							v-if="stepComponent === 'Step2'"
							:data="flag.id ? flag : false"
							:integrations="integrations"
							@done="secondDone"
					/>
					<Step3 :isPlus="isPlus"
					       v-if="stepComponent === 'Step3'"
					       :data="flag.id ? flag : false"
					       :funnelProduct="product"
					       :actions="actions"
					       :step-id="stepId" :funnel-id="funnelId" :product-id="product.id"
					       :integrationId="newData.integration_id"
					       :integrations="integrations"
					       @done="thirdDone"
					/>
					<SavingProgress v-if="stepComponent === 'SavingProgress'"/>
				</div>

				<ActivateAutomationPopup v-if="getActivateAutomationPopup" @intChanged="updateIntegration"/>

			</div>
		</template>
		<template v-slot:actions>
			<v-button border v-if="step !== 1 && !isEdit" label="Back" @click="backHundler"/>
			<v-button v-if="isEdit" label="Save changes" @click="continueHundler" :disabled="!canSave" />
			<v-button v-else label="Continue" @click="continueHundler" />
			<v-button label="Cancel" border @click="closePopup" />
		</template>
	</popup>
</template>

<script>

import Step1 from "./Step1"
import Step2 from "./Step2"
import Step3 from "./Step3"
import SavingProgress from "./SavingProgress"
import API from "@/api"
import Loading from "@/components/Loading.vue"
import {mapGetters} from "vuex"
import ActivateAutomationPopup from "@/components/popups/automation/ActivateAutomationPopup.vue"

import VButton from "@/components/base/v-button";
import Popup from "@/components/base/popup";
import SelectTriggerPopup from "@/components/popups/automation/steps/select-trigger-popup";
import SelectIntegrationPopup from "@/components/popups/automation/steps/select-integration-popup";
import ActionPopup from "@/components/popups/automation/steps/action-popup";
import IntegrationSettingsPopup from "@/components/popups/automation/steps/integration-settings-popup";

export default {
    name: "AutomationPopup",
	props:{
		flag:{},
		edit:{type:Object},
		product:{},
		isPlus:{type:Boolean},
		stepId:{},
		funnelId:{},
		automation:{},
		isEdit:{type:Boolean},
	},
    components: {
	    IntegrationSettingsPopup,
	    ActionPopup,
	    SelectIntegrationPopup,
	    SelectTriggerPopup,
	    Popup,
        Step1,
        Step2,
        Step3,
        SavingProgress,
        Loading,
        ActivateAutomationPopup,
        VButton
    },
    mixins: [API],
    data() {
      return {
        loading: false,
        integrations: [],
        actions: [],
        stepComponent: "Step1",
	      currentIntegration:{},
        step: 1,
	      localAutomation: {},
        steps: [
            {
                id: 1,
                name: "Select a trigger",
                label: "Order Form",
                step: "Step1",
                status: "active"
            },
            {
                id: 2,
                name: "Select an integration",
                label: "ActiveCampaign",
                step: "Step2",
                status: "deactivated"
            },
            {
                id: 3,
                name: "What action to trigger?",
                label: "Create an order",
                step: "Step3",
                status: "deactivated"
            }
        ],
        newData: {
          trigger_id: null,
          user_id: 0, // ignored by non-F+ automations
          funnel_id: 0, // ignored by non-F+ automations
          step_id: 0,   // ignored by non-F+ automations
          product_id: null,
          integration_id:null,
          type_id:null,
          "list":null,
          "tags":null,
          send_to_optin_email:true,
          "config":null,
          action_caption:null,
          "content":null
        },
      }
    },
    computed: {
        ...mapGetters(['getActivateAutomationPopup']),
	    canSave() {
        	// can save on 3rd step only, and cannot save "Zapier integration".
        	return this.step!==1 && this.step!==2 && this.newData.integration_id !== 13
	    },
	    user() {
        	return this.$store.state.userInfo;
	    },
    },
    methods: {
			step1Done(automation){
				console.log("step1Done", automation)
				this.localAutomation = automation;
				this.stepComponent='Step2';
			},
	    step2Done(automation){
		    console.log("step2Done", automation)
		    this.localAutomation = automation;
		    this.stepComponent='Step3';
	    },
	    async save() {
				try {

				} catch (e) {

				} finally {

				}
		    this.newData.trigger_id = parseInt(this.newData.trigger_id);
		    this.newData.product_id = parseInt(this.productId);
		    this.newData.step_id = parseInt(this.stepId);
		    this.newData.funnel_id = parseInt(this.funnelId);
		    this.newData.user_id = parseInt(this.user.id);

		    if (this.isPlus) {
			    if(this.flag.id) await this.api.wsteps.patchAutomation(this.newData.id, this.newData);
			    else await this.api.wsteps.createAutomation(this.newData);
		    } else {
			    if(this.flag.id) await this.api.steps.patchAutomation(this.newData.id, this.newData);
			    else await this.api.steps.createAutomation(this.newData);
		    }
		    this.$emit('saved');
	    },

        //UI
        updateIntegration(int) {
            var target = this.integrations.findIndex(item => item.id === int.id);
            this.integrations.splice(target, 1, int);
        },
        closePopup() {
	        // this.$emit('saved');
	        this.$emit('close');
            this.$store.commit("closeAutomationPopup")
        },
        continueHundler() {
            this.changeStep(1)
            this.$store.commit("continueBtnStatusCheck")
        },
        backHundler() {
            this.changeStep(-1)
	        if (this.step===1) { // going back to first step reset the trigger_id.
		        // this.set
	        }
        },
        changeStep(value) {
            this.step = this.step + value
            if(this.step === this.steps.length + 1) {
                this.stepComponent = "SavingProgress"
                this.steps[this.steps.length - 1].status = "completed"
                this.saveDataToAPI();
            } else {
                this.stepComponent = `Step${this.step}`
            }
            this.steps.map((step) => {
                if(this.step === step.id) {
                    step.status = "active"
                    const idx = this.steps.findIndex(item => item.id === this.step - value)
                    this.steps[idx].status = value > 0 ? "completed" : "deactivated"
                }
            })
        },
        //API
        firstDone(trigger, change=false) {
            this.newData.trigger_id = parseInt(trigger);
            var label = 'On Purchase';
            switch(trigger) {
                case 1:
                    label = 'On Purchase';
                    break;
                case 2:
                    label = 'On Refund';
                    break;
                case 3:
                    label = 'New Subscription';
                    break;
                case 4:
                    label = 'Subscription Cancelled';
                    break;
            }
            this.steps[0].label = label;
            if(change) this.changeStep(1);
        },
        async secondDone(integration) {
            this.actions = [];
            this.newData.integration_id = parseInt(integration);
            this.changeStep(1);

            var caption = 'ActiveCampaign';
            var result = this.integrations.data.find(item => parseInt(item.id) === parseInt(integration));

            this.steps[1].label = result.attributes.caption;
            caption = result.attributes.name;

            var actionResp = await this.api.steps.getActions(caption, 'get-actions');
            this.actions = await actionResp;
        },
	    thirdDone(val) {
		    this.loading = false;
            for (var prop in val) {
                if(prop === 'tags' && val[prop] !== null) this.newData[prop] = val[prop].join()
                else if(prop === 'content' && val[prop] !== null) {
                	this.newData[prop] = JSON.stringify(val[prop]);
                }
                else this.newData[prop] = val[prop]
            }
        },
        async saveDataToAPI() {
          this.newData.trigger_id = parseInt(this.newData.trigger_id);
          this.newData.product_id = parseInt(this.productId);
	        this.newData.step_id = parseInt(this.stepId);
	        this.newData.funnel_id = parseInt(this.funnelId);
	        this.newData.user_id = parseInt(this.user.id);

	        if (this.isPlus) {
		        if(this.flag.id) await this.api.wsteps.patchAutomation(this.newData.id, this.newData);
		        else await this.api.wsteps.createAutomation(this.newData);
	        } else {
		        if(this.flag.id) await this.api.steps.patchAutomation(this.newData.id, this.newData);
		        else await this.api.steps.createAutomation(this.newData);
	        }
 	        this.$emit('saved');
        },
        async init() {
        	try {
		        this.loading = true;
		        this.integrations = await this.api.steps.getIntegrations();

		        if (this.isEdit) {
			        //EDIT AUTOMATION
			        var safeStr = JSON.parse(JSON.stringify(this.flag));
			        this.newData.action_caption = safeStr.action_caption;
			        this.newData.integration_id = safeStr.integration_id;
			        this.newData.trigger_id = parseInt(safeStr.trigger_id);
			        this.newData.product_id = parseInt(this.productId);
			        this.newData.step_id = parseInt(this.stepId);
			        this.newData.funnel_id = parseInt(this.funnelId);
			        this.newData.id = safeStr.id;

			        this.changeStep(1);
			        await this.secondDone(this.newData.integration_id);

		        } else {
			        //CREATE NEW AUTOMATION
			        this.newData.product_id = parseInt(this.productId);
			        this.newData.step_id = parseInt(this.stepId);
			        this.newData.funnel_id = parseInt(this.funnelId);
		        }
	        } catch (e) {
		        this.$error(e);
	        } finally {
		        this.loading = false;
	        }
        },
    },
    async created() {
        if (this.isEdit && this.automation) {
					this.stepComponent = 'Step3'
	        this.localAutomation = JSON.parse(JSON.stringify(this.automation))
        } else {
					this.localAutomation = {
						id:0,
						trigger_id:0,
						product_id: this.product.id,
						step_id:parseInt(this.stepId),
						funnel_id:parseInt(this.funnelId),
						user_id:parseInt(this.user.id),
						send_to_optin_email: true,
					}
        }
    }
}
</script>
<style lang="scss">
.automation-popup {
	.popup {
		max-width: 800px;
	}
}
</style>
<style lang="scss" scoped>
.automation-popup {
    .bottom-btns {
        display: flex;
        justify-content: flex-end;
        padding: 15px 20px;
        border-top: 1px solid rgba(206, 207, 216, 0.32);
    }

    .body {
      height: 100%;
      display: block;
      min-height: 9px;
      position: relative;
      padding: 10px 20px;
      overflow-y: auto;
      overflow-x: hidden;
      // max-width: 740px;
    }
    .bottom-btns .button {
        margin-left: 30px;
    }
    .automation-progress-panel {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin: 10px 30px;
      padding-bottom: 5px;
        .item-prog {
            display: flex;
            align-items: flex-start;
        }
        .icon-status {
            display: flex;
            margin-right: 10px;
        }
        .icon-status.active svg {
            transform: rotate(90deg);
        }
    }
}
</style>

